// extracted by mini-css-extract-plugin
module.exports = {"container":"_3BEoWy4","columns":"_1oeNqG3"};